import { HouseImgIcon } from "../house/HouseImgIcon";

export const EventOrganisator = ({ thumbnailUrl, name, imgClass = "w-5 h-5 md:h-8 md:w-8", textClass = "text-2xs md:text-xs" }) => {

    return (
        <p className={`inline-flex w-full items-center text-left ${textClass} font-sans text-black font-semibold`}>
            <span className={`block mr-2 ${imgClass}`}>
                {thumbnailUrl ? (
                    <img
                        className="rounded-full"
                        src={thumbnailUrl}
                        alt=""
                    />
                ) : (
                    <HouseImgIcon className="bg-primary text-white rounded-full" />
                )}
            </span>
            {name}
        </p>
    );
};